import React, { useState } from 'react';
import { round } from 'lodash';
import PropTypes from 'prop-types';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import turf from '@turf/turf';

const VideoLatLngGo = ({ currentFeature, isClickableDivHidden, isPublic, sendToClosestPoint }) => {
  if (isPublic) {
    return '';
  }

  const [inputLng, setInputLng] = useState(turf.getCoord(currentFeature)[0]);
  const [inputLat, setInputLat] = useState(turf.getCoord(currentFeature)[1]);
  const [enterLatLng, setEnterLatLng] = useState(false);

  let [desLng, desLat] = turf.getCoord(currentFeature);
  if (enterLatLng) {
    desLng = inputLng;
    desLat = inputLat;
  }

  return (
    <InputGroup size="sm">
      <InputGroup.Prepend>
        <InputGroup.Text>Lon</InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        name="longitude"
        max="180.000000"
        min="-180.000000"
        value={round(desLng, 6)}
        onChange={event => {
          setEnterLatLng(true);
          setInputLng(event.target.value);
          setInputLat(event.target.form.latitude.value);
        }}
      />
      <InputGroup.Prepend>
        <InputGroup.Text>Lat</InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        type="number"
        name="latitude"
        max="90.000000"
        min="-90.000000"
        value={round(desLat, 6)}
        onChange={event => {
          setEnterLatLng(true);
          setInputLng(event.target.form.longitude.value);
          setInputLat(event.target.value);
        }}
      />
      <InputGroup.Append>
        <Button
          type="submit"
          form="videoButtons"
          variant="primary"
          disabled={isClickableDivHidden}
          onClick={event => {
            setEnterLatLng(false);
            sendToClosestPoint(event);
          }}
        >
          <FontAwesomeIcon icon="location-arrow" size="sm" /> Go
        </Button>
      </InputGroup.Append>
    </InputGroup>
  );
};

VideoLatLngGo.propTypes = {
  currentFeature: PropTypes.object.isRequired,
  isClickableDivHidden: PropTypes.bool.isRequired,
  isPublic: PropTypes.bool.isRequired,
  sendToClosestPoint: PropTypes.func.isRequired
};

export default VideoLatLngGo;
